<template lang="pug">
  modal(:active="active" title="Anexos do comentário" @close="close")
    div(slot="modal-body")
      .columns.my-2.p-2.align-center.item.s-rounded(v-for="anexo, index in anexos" :class="{destroy: anexo._destroy, added: !anexo.id}")
        .column.col-auto
          img.img-responsive.image(:src="anexo.file_info.thumb")
        .column
          div {{ anexo.file_info.name }}
          .text-gray {{ anexo.file_info.size / 1000 }}kb
          abbr.text-small.pt-2 {{ anexo.file_info.created_at | date }}
          div(v-if="anexo._destroy") #[cite.text-error Este anexo será removido após a edição]
          div(v-else-if="!anexo.id") #[cite.text-success Este anexo será adicionado após a edição]
        .column.col-auto
          a.btn.btn-error.btn-action.tooltip.tooltip-left(
            v-if="!anexo._destroy"
            @click="$emit('remove', index)"
            data-tooltip="Remover"
          )
            i.fa.fa-trash
          a.btn.btn-primary.btn-action.tooltip.tooltip-left(
            v-else
            @click="$emit('unremove', index)"
            data-tooltip="Cancelar remoção"
          )
            i.fa.fa-undo
</template>

<script>
export default {
  data() {
    return {
      active: false,
    }
  },
  watch: {
    anexos() {
      if (this.anexos.length === 0) this.close()
    },
  },
  props: {
    anexos: { type: Array, required: true },
  },
  methods: {
    open() {
      this.active = true
    },
    close() {
      this.active = false
    },
  },
}
</script>

<style lang="stylus" scoped>
.image
  max-width 100px

.item
  border-bottom 1px solid #eee

.destroy
  background-color #ffece0

.added
  background-color #ebf3e8
</style>
